// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-cont {
  height: 7px;
  width: 100%;
  border-radius: 4px;
  background-color: #d0d0d0;
  position: relative;
}
.progress-cont .progress {
  width: 0;
  height: 100%;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  border-radius: 4px;
  background-color: #4c97cb;
  transition: 0.5s all;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/document-upload/document-upload-drag-and-drop/document-upload-progress/document-upload-progress.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AACF;AACE;EACE,QAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;AACJ","sourcesContent":[".progress-cont {\r\n  height: 7px;\r\n  width: 100%;\r\n  border-radius: 4px;\r\n  background-color: #d0d0d0;\r\n  position: relative;\r\n\r\n  .progress {\r\n    width: 0;\r\n    height: 100%;\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: 0;\r\n    left: 0;\r\n    border-radius: 4px;\r\n    background-color: #4c97cb;\r\n    transition: 0.5s all;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
